import { motion } from "framer-motion";
import { fadeUp, staggerParent, lineReveal, viewport } from "@/lib/motion";

export const Reveal = ({ children, className, delay = 0, as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
    >
      {children}
    </M>
  );
};

export const RevealGroup = ({ children, className }) => (
  <motion.div
    className={className}
    variants={staggerParent}
    initial="hidden"
    whileInView="show"
    viewport={viewport}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className, custom = 0 }) => (
  <motion.div className={className} variants={fadeUp} custom={custom}>
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero headlines
export const MaskLine = ({ children, custom = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      variants={lineReveal}
      custom={custom}
    >
      {children}
    </motion.span>
  </span>
);
